import React from 'react'

import {
    Modal,
    Button,
    Row,
    Col,
    message,
    Select
} from 'antd'

import {
    _getDocCategories
} from '../../services'

const { Option } = Select

class TagEditor extends React.Component {

    state = {
        render: false,
        visible: false,
        subCategoryList: [],
        activeTag: false
    }
    
    render(){

        const { render, visible, subCategoryList } = this.state

        const { tags } = this.props

        return(
            <div style={{display: 'inline'}}>
                {render && 
                    <Modal
                        afterClose={this.afterCloseModal}
                        onCancel={this.closeModal}
                        // onOk={this.closeModal}
                        centered closable={false}
                        // okText="Done"
                        footer={null}
                        okButtonProps={{
                            type: 'default'
                        }}
                        visible={visible}
                    >   
                        <div>
                            <Select 
                            onChange={this.handleSelect}
                            placeholder="Select Sub Category Tag"
                            style={{width: 400}}>
                                {subCategoryList.map( _subCategory => (
                                    <Option
                                        value={_subCategory.titleUrl}
                                    >
                                        {_subCategory.title}
                                    </Option>
                                ))}
                            </Select>
                            <Button
                                onClick={this.handleAddTag}
                                type="primary"
                                disabled={!this.state.activeTag}
                            >Add</Button>
                        </div>
                        <div style={{marginTop: 16}}>
                            {tags.map( _tag => (
                                <Row style={{marginBottom: 6}} type="flex" justify="space-between">
                                    <Col>
                                        <span>{_tag}</span>
                                    </Col>
                                    <Col>
                                        <Button
                                            onClick={()=>this.removeTag(_tag)}
                                            size="small"
                                            icon="close"
                                            shape='circle'
                                            type="danger"
                                        />
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    </Modal>}
                <a
                    onClick={this.openModal}
                >Tag Editor</a>
            </div>
        )
    }

    constructor(props){
        super(props)

        _getDocCategories()
        .then( res => {

            const subCategoryList = res.data.docCategories.reduce((acc, curr) => {

                if( curr.active ){
                    curr.subCategories.map( _subCategory => {
                        if( _subCategory.active ){
                            acc.push( _subCategory )
                        }
                    })
                }

                return acc

            },[])

            this.setState({
                subCategoryList
            })
        })
    }

    handleSelect = (tag) => {
        this.setState({ activeTag: tag})
    }

    handleAddTag = () => {
        const { activeTag } = this.state

        if( this.props.tags.includes( activeTag )){
            return message.warning("tag already added!")
        }

        this.props.addTag( activeTag )

    }

    removeTag = (tag) => {
        
        this.props.removeTag(tag)

    }

    afterCloseModal = () => {
        this.setState({
            render: false
        })
    }

    closeModal = () => {
        this.setState({
            visible: false,
            activeTag: false
        })
    }

    openModal = () => {
        this.setState({
            visible: true,
            render: true
        })
    }
}

export default TagEditor


// WEBPACK FOOTER //
// ./src/components/docs/tag-editor.js